import { Products as Page } from './Products.main';
import { ProductsHeader as Header } from './ProductsHeader';

export { Filters } from './Filters';
export { ProductsTable } from './ProductsTable';

export const Products = { Header, Page };
